import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { RequestDetailEvaluator } from '../shared/request-detail-evaluator.model';

@Component({
  selector: 'app-subject-evaluate',
  templateUrl: './subject-evaluate.component.html',
  styleUrls: ['./subject-evaluate.component.scss']
})
export class SubjectEvaluateComponent implements OnInit, OnChanges {

  aprobada = '7.7';
  aprobadaLabel = 'Aprobada';
  reprobada = '8.8';
  reprobadaLabel = 'Reprobada';
  displayedColumns: string[] = ['codigo', 'materia', 'institucion', 'periodo',  'nota', 'creditos', 'programa'];
  dataSource;

  @Input() subjects: RequestDetailEvaluator[];



  constructor() {
    this.dataSource = this.subjects;
  }

  ngOnInit() {
    this.dataSource = this.subjects;
  }

  ngOnChanges() {
    this.dataSource = this.subjects;
  }

  getScore(nota) {
      if (nota ===  this.aprobada) {
        return this.aprobadaLabel;
      } else if (nota === this.reprobada) {
        return this.reprobadaLabel;
      } else {
        return nota;
      }
  }

}
